import { CartLinesUpdateEvent, CartErrorEvent, StandardEvents } from '@shopify/events';

/**
 * Minimal, self-contained "quick add" behavior for product cards.
 * Deliberately avoids Horizon's own quick-add-component/product-form-component
 * web component chain -- adds directly via fetch to Shopify's cart API -- but
 * still dispatches the same CartLinesUpdateEvent Horizon's cart-icon and
 * cart-drawer components listen for, so the header count and drawer update
 * live without a page refresh.
 */
document.addEventListener('click', function (event) {
  const button = event.target.closest('.simple-quick-add__button[data-variant-id]');
  if (!button || button.disabled) return;

  event.preventDefault();

  const label = button.querySelector('.simple-quick-add__label');
  const originalText = label.textContent;
  const variantId = button.getAttribute('data-variant-id');

  button.disabled = true;
  label.textContent = '...';

  const deferredEventPromise = CartLinesUpdateEvent.createPromise();

  document.dispatchEvent(
    new CartLinesUpdateEvent({
      action: 'add',
      context: 'product',
      lines: [{ merchandiseId: variantId, quantity: 1 }],
      promise: deferredEventPromise.promise,
    })
  );

  fetch(Theme.routes.cart_add_url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
  })
    .then(function (response) {
      return response.json().then(function (data) {
        return { ok: response.ok, data: data };
      });
    })
    .then(function (result) {
      if (!result.ok) {
        throw new Error((result.data && result.data.description) || 'Add to cart failed');
      }

      return fetch(`${Theme.routes.cart_url}.json`)
        .then(function (response) {
          return response.json();
        })
        .then(function (ajaxCart) {
          deferredEventPromise.resolve({
            cart: CartLinesUpdateEvent.createCartFromAjaxResponse(ajaxCart),
            detail: {
              source: 'simple-quick-add',
              itemCount: 1,
            },
          });

          button.classList.add('is-added');
          label.textContent = 'Added';

          setTimeout(function () {
            button.disabled = false;
            button.classList.remove('is-added');
            label.textContent = originalText;
          }, 1800);
        });
    })
    .catch(function (error) {
      document.dispatchEvent(
        new CartErrorEvent({
          error: error && error.message ? error.message : 'Add to cart failed',
          code: 'INVALID',
          detail: {},
        })
      );
      deferredEventPromise.reject(error);

      label.textContent = 'Error';
      setTimeout(function () {
        button.disabled = false;
        label.textContent = originalText;
      }, 1800);
    });
});
